/**
 * Matches ProfileTier.High in MediaServer.Api — the tier DVR rewind always recalls.
 * The server pins exactly one DVR buffer per camera (see RelaySyncService.SelectDvrTier)
 * rather than following whichever tier a viewer selected for live, so rewind concerns
 * this stream and no other.
 */
export const REWIND_TIER_NAME = 'HIGH';
